import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import { formatNumber, isNullOrUndefined, stringIsNullOrEmpty, numberPatternFormat, truncateNumber, getDisplayName, formatDate, formatDateMMDDYYYY } from '../Common/Utilities';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import Tooltip from '@mui/material/Tooltip';

import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export class POHeaderLookup extends React.Component {
	constructor(props) {
		super(props);

		this.vendorCode = null;
		this.siteId = null;
		this.serviceTermStartDate = null;
		this.serviceTermEndDate = null;
		this.clientCode = null;
		this.invoiceDocumentId = 0;
		this.searchText = "";
		this.inProgress = false;
		this.doFetchRecords = true;
		this.baseData = [];

		this.state = {
			poCode: null,
			data: [],
			rowData: null,
			selectedRows: [],
			lineAmount: parseFloat(this.props.info.ioInvoiceAmount) || 0,
			includeAllPO:
				this.props.info.serviceDateFilterForIoLookup === "OPTIONAL_OVERRIDE" &&
					(
						stringIsNullOrEmpty(this.props.info.serviceTermStartDate) &&
						stringIsNullOrEmpty(this.props.info.serviceTermEndDate)
					)
					? true
					: false
		};

		this.checkbox_clickHandler = this.checkbox_clickHandler.bind(this);
		this.close_clickHandler = this.close_clickHandler.bind(this);
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.handleIncludeAllIOChange = this.handleIncludeAllIOChange.bind(this);
		this.gridRef = React.createRef();
	}

	componentDidMount() {
		this.vendorCode = this.props.info.vendorCode;
		this.siteId = this.props.info.siteId;
		this.serviceTermStartDate = this.props.info.serviceTermStartDate;
		this.serviceTermEndDate = this.props.info.serviceTermEndDate;
		this.invoiceDocumentId = this.props.info.invoiceDocumentId;
		this.clientCode = this.props.info.clientCode;

		if (this.props.info.openDialog && this.doFetchRecords && !this.inProgress) {
			this.inProgress = true;
			this.fetchRecords();
		}
	}
	componentDidUpdate(prevProps) {
		var that = this;
		if (this.props.info.vendorCode !== this.vendorCode ||
			this.props.info.siteId !== this.siteId ||
			this.props.info.serviceTermStartDate !== this.serviceTermStartDate ||
			this.props.info.serviceTermEndDate !== this.serviceTermEndDate ||
			this.props.info.invoiceDocumentId !== this.invoiceDocumentId ||
			this.props.info.clientCode !== this.clientCode) {
			this.vendorCode = this.props.info.vendorCode;
			this.siteId = this.props.info.siteId;
			this.serviceTermStartDate = this.props.info.serviceTermStartDate;
			this.serviceTermEndDate = this.props.info.serviceTermEndDate;
			this.invoiceDocumentId = this.props.info.invoiceDocumentId;
			this.clientCode = this.props.info.clientCode;

			this.doFetchRecords = true;
			this.inProgress = false;

			const shouldIncludeAllPO =
				this.props.info.serviceDateFilterForIoLookup === "OPTIONAL_OVERRIDE" &&
				(
					stringIsNullOrEmpty(this.props.info.serviceTermStartDate) &&
					stringIsNullOrEmpty(this.props.info.serviceTermEndDate)
				);

			this.setState({
				data: [],
				rowData: null,
				includeAllPO: shouldIncludeAllPO
			});
		}
		if (
			this.props.info.serviceDateFilterForIoLookup === "OPTIONAL_OVERRIDE" &&
			(
				this.props.info.serviceTermStartDate !== prevProps.info.serviceTermStartDate ||
				this.props.info.serviceTermEndDate !== prevProps.info.serviceTermEndDate
			)
		) {
			const shouldIncludeAllPO =
				stringIsNullOrEmpty(this.props.info.serviceTermStartDate) &&
				stringIsNullOrEmpty(this.props.info.serviceTermEndDate);

			if (this.state.includeAllPO !== shouldIncludeAllPO) {
				this.setState({ includeAllPO: shouldIncludeAllPO });
			}
		}
		if (this.props.info.openDialog && !prevProps.info.openDialog) {
			const clearedData = this.state.data.map(row => ({
				...row,
				allocatedAmount: undefined,
				tempAllocatedInput: undefined,
				isInvalidAllocation: false,
				hasShownError: false
			}));

			this.setState(
				{
					data: clearedData,
					selectedRows: [],
					rowData: null
				},
				() => {
					this.applySelectionAndReorder(this.props.info.poCode);
				}
			);
		}


		if (this.props.info.openDialog && this.doFetchRecords && !this.inProgress) {
			this.inProgress = true;
			this.fetchRecords();
		}
		else if (this.props.info.poCode !== this.state.poCode) {
			var rowData = this.getRowData(this.props.info.poCode);
			this.setState({ poCode: this.props.info.poCode, rowData: rowData });
		}
	}
	canDeselectAllSelected = () => {
		const statuses = this.props.info.lineStatuses || [];

		//If ANY selected line is approved => block deselect
		return !statuses.some(status => {
			const s = Number(status);
			return !isNaN(s) && s >= 70 && s !== 100;
		});
	};


	applySelectionAndReorder(poCode, dataOverride = null) {
		const sourceData = dataOverride || this.baseData;
		if (!poCode || !sourceData || sourceData.length === 0) return;

		const data = [...sourceData];
		const index = data.findIndex(r => r.poCode === poCode);
		if (index === -1) return;

		const selectedRow = data.splice(index, 1)[0];
		data.unshift(selectedRow);

		data.forEach((row, i) => (row.rowId = i));

		if (this.props.info.allowMultipleSelection) {
			this.setState({
				data,
				selectedRows: [selectedRow],
				rowData: null,
				poCode
			});
		} else {
			this.setState({
				data,
				rowData: selectedRow,
				selectedRows: [],
				poCode
			});
		}
	}

	checkbox_clickHandler(event) {
		const { allowMultipleSelection } = this.props.info;
		const rowIndex = this.state.data.findIndex(r => r.poCode === event.target.value);
		if (rowIndex === -1) return;
		const rowData = this.state.data[rowIndex];

		if (allowMultipleSelection) {
			const selectedRows = [...this.state.selectedRows];
			const index = selectedRows.findIndex(row => row.poCode === rowData.poCode);
			if (index > -1) {
				selectedRows.splice(index, 1);
				this.handleIOSelectionToggle(rowData.rowId, false);
			} else {
				selectedRows.push(rowData);
				this.handleIOSelectionToggle(rowData.rowId, true);
			}
			this.setState({ selectedRows });
		} else {
			const isSameRowSelected =
				this.state.rowData &&
				this.state.rowData.poCode === rowData.poCode;
			//if (isSameRowSelected && !this.canDeselectAllSelected()) {
			//	//toast.error(
			//	//	'One or more selected lines are approved. Select another IO/PO Number instead.'
			//	//);
			//	return;
			//}

			this.setState({
				rowData: isSameRowSelected ? null : rowData
			});
		}

	}


	close_clickHandler(event) {
		this.searchText = "";

		if (this.props.onClose) {
			const { allowMultipleSelection } = this.props.info;

			if (allowMultipleSelection) {
				const normalizedSelectedRows = (this.state.selectedRows || [])
					.map((selectedRow) => this.state.data.find((row) => row.poCode === selectedRow.poCode) || selectedRow)
					.map((row) => {
						const allocated = parseFloat(row.allocatedAmount);
						return {
							...row,
							allocAmount: isNaN(allocated) ? 0 : allocated
						};
					});

				this.props.onClose(event, normalizedSelectedRows);
			} else {
				this.props.onClose(event, [this.state.rowData]);
				this.setState({ selectedRows: [], rowData: null });
			}
		}
	}

	handleClose = (event) => {
		if (this.state.rowData && this.state.rowData.length > 0) {
			this.props.onClose(event, this.state.rowData);
		} else {
			this.props.onClose(event, []);
		}
		this.setState({ selectedRows: [], rowData: null });
	};

	refresh_clickHandler(event) {
		if (!stringIsNullOrEmpty(this.gridRef?.current?.filterText)) {
			this.props.info.inProgress(true);

			httpGet("/api/invoicedocument/refetchpoinfo/" + this.props.info.modelDefId + '?poCode=' + encodeURIComponent(this.gridRef?.current?.filterText))
				.then((response) => {
					var data = response.data;
					this.doFetchRecords = true;
					this.props.info.inProgress(false);
					let poexist = this.state.data.some((e, i) => e.poCode === data.poCode);
					if (!poexist) {
						data.rowId = (this.state?.data?.length || 0) + 5000 + 1;
					}
					//this.setState({ data: [...this.state.data,data] });
					this.setState({ data: [] });

				}).catch((error) => {
					this.props.info.inProgress(false);
					toast.error('Error fetching IO/PO Number, either the IO/PO number is invalid or the record does not exists.');
				});
		}
	}

	fetchRecords() {
		if (this.state.data.length === 0) {
			if (!this.props.info.vendorCode) return;
			let url = `/api/lookup/poheaderlistbyvendor/${this.props.info.modelDefId}`;

			url += `/${isNullOrUndefined(this.props.info.invoiceDocumentId) ? 0 : this.props.info.invoiceDocumentId}`;

			url += `?vendorCode=${encodeURIComponent(this.props.info.vendorCode)}`;

			if (!isNullOrUndefined(this.props.info.clientCode) && this.props.info.clientCode !== "") {
				url += `&clientCode=${encodeURIComponent(this.props.info.clientCode)}`;
			}
			else
				url += `&clientCode=${null}`;
			let startDate = this.props.info.serviceTermStartDate;
			let endDate = this.props.info.serviceTermEndDate;
			url += `&serviceTermStartDate=${stringIsNullOrEmpty(startDate) ? 'null' : startDate}`;
			url += `&serviceTermEndDate=${stringIsNullOrEmpty(endDate) ? 'null' : endDate}`;

			let serviceDateFilterApplicable = 1;
			if (
				this.props.info.serviceDateFilterForIoLookup === "NOT_APPLICABLE" ||
				this.props.info.modelDefId !== 1
			) {
				serviceDateFilterApplicable = 0;
			} else if (this.props.info.serviceDateFilterForIoLookup === "OPTIONAL_OVERRIDE") {
				serviceDateFilterApplicable = this.state.includeAllPO ? 0 : 1;
			}

			url += `&serviceDateFilterApplicable=${serviceDateFilterApplicable}`;

			this.props.info.inProgress(true);

			httpGet(url)
				.then((response) => {
					const data = response.data.map((e, i) => ({
						...e,
						rowId: i,
						allocatedAmount: undefined,
						tempAllocatedInput: undefined,
						isInvalidAllocation: false,
						hasShownError: false
					}));
					this.baseData = data;

					this.inProgress = false;
					this.doFetchRecords = false;

					this.setState(
						{
							vendorCode: this.props.info.vendorCode,
							siteId: this.props.info.siteId,
							poCode: this.props.info.poCode,
							data: data,
							rowData: null,
							selectedRows: []
						},
						() => {
							this.applySelectionAndReorder(this.props.info.poCode, data);
						}
					);

					this.props.info.inProgress(false);
				})
				.catch((error) => {
					this.props.info.inProgress(false);
					toast.error('Error fetching IO/PO Number');
					this.close_clickHandler();
				});
		}
	}

	handleIncludeAllIOChange = (event) => {
		const isChecked = event.target.checked;

		if (this.state.includeAllPO === isChecked) return;

		this.doFetchRecords = true;
		this.inProgress = false;

		this.setState({
			includeAllPO: isChecked,
			data: []
		});
	};

	getRowData(value) {
		var data = this.state.data;

		return data[data.findIndex(d => d.poCode === value)];
	}

	calculateRemainingAmount() {
		const { selectedRows } = this.state;

		const totalAllocatedAmount = this.state.selectedRows.reduce((sum, row) => {
			return sum + (row.allocatedAmount || 0);
		}, 0);
		const remainingAmountColor =
			Math.round(totalAllocatedAmount * 100) / 100 === Math.round(parseFloat(this.props.info.ioInvoiceAmount || 0) * 100) / 100
				? 'green'
				: 'red';
		return parseFloat(totalAllocatedAmount.toFixed(2));
	}

	handleAllocatedAmountChange = (rowId, inputValue) => {
		const updatedRows = [...this.state.data];
		const index = updatedRows.findIndex(r => r.rowId === rowId);
		if (index === -1) return;

		const row = updatedRows[index];
		const numericValue = parseFloat(inputValue);
		const remaining = row.poAmount - row.consumedAmount;

		const lineAmount = parseFloat(this.props.info.ioInvoiceAmount || 0);
		const selectedRowIds = updatedRows.filter(r => r.checkboxSelected).map(r => r.rowId);
		const totalAllocatedExceptCurrent = updatedRows
			.filter(r => r.rowId !== rowId && selectedRowIds.includes(r.rowId))
			.reduce((sum, r) => sum + (parseFloat(r.allocatedAmount) || 0), 0);
		const totalIncludingThis = totalAllocatedExceptCurrent + (numericValue || 0);

		if (inputValue === '') {
			row.tempAllocatedInput = '';
			row.allocatedAmount = undefined;
			row.isInvalidAllocation = false;
			row.hasShownError = false;
		} else if (remaining < 0 && numericValue > 0) {
			// Disallow setting positive values
			rowToUpdate.tempAllocatedInput = inputValue;
			rowToUpdate.allocatedAmount = undefined;
			rowToUpdate.isInvalidAllocation = true;

			if (!rowToUpdate.hasShownError) {
				toast.error("Cannot allocate a positive amount to an IO with negative remaining.");
				rowToUpdate.hasShownError = true;
			}

			this.setState({ data: updatedRows });
			return;
		} else if (!isNaN(numericValue) && totalIncludingThis > lineAmount) {
			row.tempAllocatedInput = inputValue;
			row.allocatedAmount = numericValue;
			//row.isInvalidAllocation = true;
			//if (!row.hasShownError) {
			//	row.hasShownError = true;
			//	toast.error("Total allocated amount cannot exceed the invoice line amount.");
			//}
		} else if (!isNaN(numericValue)) {
			row.tempAllocatedInput = inputValue;
			row.allocatedAmount = numericValue;
			row.isInvalidAllocation = false;
			row.hasShownError = false;
		}

		this.setState({ data: updatedRows });
	};


	handleIOSelectionToggle = (rowId, isSelected) => {
		const updatedRows = [...this.state.data];
		const index = updatedRows.findIndex(r => r.rowId === rowId);
		if (index === -1) return;

		const row = updatedRows[index];
		const remaining = row.poAmount - row.consumedAmount;
		const lineAmount = parseFloat(this.props.info.ioInvoiceAmount || 0);
		const totalAllocated = updatedRows.reduce((sum, r) => sum + (r.allocatedAmount || 0), 0);
		const availableToAllocate = lineAmount - totalAllocated;

		if (isSelected) {
			let remaining = row.poAmount - row.consumedAmount;

			// If remaining is negative, still allow selection, but allocate 0.00
			if (remaining < 0) remaining = 0;

			const lineAmount = parseFloat(this.props.info.ioInvoiceAmount || 0);
			const totalAllocated = updatedRows.reduce((sum, r) => sum + (r.allocatedAmount || 0), 0);
			const availableToAllocate = lineAmount - totalAllocated;

			const amountToAllocate = Math.min(remaining, availableToAllocate);
			const rounded = Math.round(amountToAllocate * 100) / 100;

			row.allocatedAmount = rounded;
			row.tempAllocatedInput = formatNumber(rounded);
		} else {
			row.allocatedAmount = undefined;
			row.tempAllocatedInput = undefined;
		}

		row.isInvalidAllocation = false;
		row.hasShownError = false;

		this.setState({ data: updatedRows });
	};



	getRefreshButton() {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}>
			<Tooltip key={1} title={'Pull data by IO/PO Code'}>
				<RefreshIcon key={2} />
			</Tooltip>
		</IconButton>;
	}

	getIncludeAllIO() {
		if (this.props.info.serviceDateFilterForIoLookup === "OPTIONAL_OVERRIDE") {
			return (
				<div
					title=""
					style={{
						display: 'flex',
						alignItems: 'center',
						fontWeight: 'normal',
						paddingRight: '10px',
						paddingLeft: '3px',
						whiteSpace: 'nowrap'
					}}
				>
					<Checkbox
						checked={this.state.includeAllPO}
						onChange={this.handleIncludeAllIOChange}
					/>
					<span style={{ whiteSpace: 'nowrap', fontSize: '1.25rem', fontWeight: 400, lineHeight: 1.6 }}>
						Include All IO/PO
					</span>
				</div>
			);
		}
		return null;
	}

	render() {
		const cellStyle = { paddingRight: 45 };
		const headerStyle = { textAlign: 'right' };
		const { allowMultipleSelection } = this.props.info;
		const { ioInvoiceAmount } = this.props.info;
		const vendorInfo = this.props.info.vendorCode + (this.props.info.vendorName ? ' - ' + this.props.info.vendorName : '');
		const totalAllocatedAmount = this.calculateRemainingAmount();
		const remainingAmountColor = parseFloat(totalAllocatedAmount.toFixed(2)) === parseFloat(parseFloat(ioInvoiceAmount).toFixed(2)) ? 'green' : 'red';
		const lineAmount = this.props.info.lineAmount;
		const hasSingleLineAmount = lineAmount !== null && lineAmount !== undefined && lineAmount !== '' && Number.isFinite(Number(lineAmount.toString().replace(/,/g, '')));
		const { serviceTermStartDate, serviceTermEndDate } = this.props.info;

		let serviceDateDisplay = '-';
		const start = formatDateMMDDYYYY(serviceTermStartDate) || '';
		const end = formatDateMMDDYYYY(serviceTermEndDate) || '';
		if (start || end) {
			serviceDateDisplay = `${start?.split(',')[0]} - ${end?.split(',')[0]}`;
		}

		return (
			<Dialog open={this.props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="xl">
				<DialogTitle>
					<div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>

						<span style={{ fontSize: 'large', fontWeight: 'bold' }}>Select IO/PO Number</span>

						<div style={{ display: 'flex', marginLeft: '40px', alignItems: 'center', flexWrap: 'wrap' }}>
							{this.props.info.vendorCode && (
								<span style={{ fontSize: 'medium', whiteSpace: 'nowrap', marginLeft: '20px' }}>
									Vendor : <span>&nbsp;</span>
									<span className="truncate" style={{ fontSize: 'medium', textOverflow: 'ellipsis', fontWeight: 'normal' }} title={vendorInfo}>
										{vendorInfo}
									</span>
								</span>
							)}
							{hasSingleLineAmount && (
								<span style={{ fontSize: 'large', whiteSpace: 'nowrap', marginLeft: '20px' }}>
									Line Amount:{' '}
									<span className="truncate" style={{ fontWeight: 'bold', textOverflow: 'ellipsis' }} title={numberPatternFormat(lineAmount)}>
										{truncateNumber(numberPatternFormat(lineAmount))}
									</span>
								</span>
							)}
							{allowMultipleSelection && (
								<span style={{ fontSize: 'large', marginLeft: '20px' }}>
									Allocated Amount:{' '}
									<span className="truncate" style={{ color: remainingAmountColor, fontWeight: 'bold', textOverflow: 'ellipsis' }} title={formatNumber(totalAllocatedAmount)}>
										{truncateNumber(formatNumber(totalAllocatedAmount))}
									</span>
								</span>
							)}
							{this.props.info.modelDefId === 1 && this.props.info.serviceDateFilterForIoLookup != "NOT_APPLICABLE" && (
								<span style={{ fontSize: 'large', whiteSpace: 'nowrap', marginLeft: '20px' }}>
									Service Date: <span>&nbsp;</span>
									<span style={{ fontWeight: 'normal', color: '#444' }}>
										{serviceDateDisplay}
									</span>
								</span>
							)}
						</div>




						<IconButton
							aria-label="close"
							onClick={this.handleClose}
							style={{
								position: "absolute",
								right: 0,
								top: '50%',
								transform: 'translateY(-50%)',
								color: (theme) => theme.palette.grey[500]
							}}
						>
							<CloseIcon />
						</IconButton>
					</div>
				</DialogTitle>





				<DialogContent>
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>

						{/*{allowMultipleSelection && this.state.selectedRows.length > 0 && (*/}
						{/*	<div style={{*/}
						{/*		fontSize: '14px',*/}
						{/*		fontWeight: 500,*/}
						{/*		color: '#444',*/}
						{/*		paddingRight: '34px',*/}
						{/*		paddingBottom: '8px',*/}
						{/*		whiteSpace: 'pre-wrap',*/}
						{/*		lineHeight: '1.6'*/}
						{/*	}}>*/}
						{/*		<span style={{*/}
						{/*			fontWeight: 700*/}

						{/*		}}>*/}
						{/*			Remaining Amt:</span>{' '}*/}
						{/*		(*/}
						{/*		{this.state.selectedRows.map((row, index) => {*/}
						{/*			const remaining = row.poAmount - row.consumedAmount - (row.allocatedAmount || 0);*/}
						{/*			const displayAmount = formatNumber(Math.max(remaining, 0));*/}
						{/*			return `${row.poCode}: ${displayAmount}`;*/}
						{/*		}).join(', ')}*/}
						{/*		)*/}
						{/*	</div>*/}

						{/*)}*/}

						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							disableVirtualization
							gridRef={this.gridRef}
							title=""
							leftCustomComponent={this.getIncludeAllIO()}
							columnVisibilityModel={{
								'mediaPlanName': this.props.info.modelDefId === 1,
								'deliveryAmount': this.props.info.modelDefId === 1,
								'mediaType': this.props.info.modelDefId === 1,
								'siteName': this.props.info.modelDefId === 1,
								'serviceStartDate': this.props.info.modelDefId === 1
							}}
							columns={[
								{
									headerName: ' ',
									field: 'chkPOCode',
									width: 40,
									resizable: false, sortable: false,
									renderCell: rowData =>
										<Checkbox
											color="default"
											name="chk"
											checked={allowMultipleSelection
												? this.state.selectedRows.some(row => row.poCode === rowData.row.poCode)
												: this.state.rowData != null && this.state.rowData !== undefined && rowData.row.poCode === this.state.rowData.poCode}
											value={rowData.row.poCode}
											onClick={this.checkbox_clickHandler}
										/>
								},
								{
									headerName: (this.props.info.modelDefId === 2 ? 'PO Number' : 'IO/PO Number'),
									field: 'poCode',
									flex: 0.6,
									renderCell: rowData => (
										<div style={{ wordBreak: 'break-word' }}>
											<div>{rowData.row.poCode}</div>
											<div style={{ fontSize: '0.9em', color: 'grey', fontWeight: 'bold' }}>{rowData.row.mediaType}</div>
										</div>
									)
								},
								,
								{
									headerName: getDisplayName('site'),
									field: 'siteName',
									width: 100
								},
								...(allowMultipleSelection ? [
									{
										headerName: 'Allocated Amount',
										field: 'allocatedAmount',
										flex: 0.5,
										align: 'right',
										headerAlign: 'right',
										renderCell: (rowData) => {
											const row = rowData.row;
											const isRowSelected = this.props.info.allowMultipleSelection
												? this.state.selectedRows.some(r => r.poCode === row.poCode)
												: this.state.rowData && this.state.rowData.poCode === row.poCode;

											const isDisabled = !isRowSelected;

											return (
												<input
													type="text"
													inputMode="decimal"
													disabled={isDisabled}
													className={`MuiInputBase-input MuiInput-input ${row.isInvalidAllocation ? 'MuiInput-input-error' : ''}`}
													style={{
														width: '100%',
														textAlign: 'right',
														padding: '6px 10px',
														border: row.isInvalidAllocation ? '1px solid red' : '1px solid #c6c6c6',
														borderRadius: 6,
														backgroundColor: isDisabled ? '#f0f0f0' : 'white'
													}}
													value={
														row.tempAllocatedInput !== undefined
															? row.tempAllocatedInput
															: row.allocatedAmount !== undefined
																? formatNumber(row.allocatedAmount)
																: ''
													}

													onFocus={(e) => {
														// Remove formatting (commas, etc.)
														const updatedRows = [...this.state.data];
														const index = updatedRows.findIndex(r => r.rowId === row.rowId);
														if (index !== -1) {
															const currentRow = updatedRows[index];
															let value = e.target.value.replace(/,/g, '');
															if (value === '0.00') value = '0';
															currentRow.tempAllocatedInput = value;
															this.setState({ data: updatedRows }, () => {
																e.target.value = value;
																e.target.select();
															});
														}
													}}

													onChange={(e) => {
														const cleanedInput = e.target.value;
														const inputValue = cleanedInput.replace(/,/g, '');
														const updatedRows = [...this.state.data];
														const index = updatedRows.findIndex(r => r.rowId === row.rowId);
														if (index === -1) return;

														const rowToUpdate = updatedRows[index];
														const validDecimal = /^-?(?:\d+|\d*\.\d{0,2})$/;
														const numericValue = parseFloat(inputValue);
														const r1 = parseFloat(row.poAmount - row.consumedAmount);
														const remaining1 = formatNumber(r1);
														const remaining = remaining1.replace(/,/g, '');
														const invoiceLineAmount = parseFloat(this.props.info.ioInvoiceAmount || 0);

														const totalAllocatedExcludingThis = updatedRows
															.filter(r => r.rowId !== row.rowId && r.checkboxSelected)
															.reduce((sum, r) => sum + (parseFloat(r.allocatedAmount) || 0), 0);

														const totalAllocatedIncludingThis = totalAllocatedExcludingThis + (numericValue || 0);

														// Intermediate typing states
														if (inputValue === '' || inputValue === '-' || inputValue === '.' || inputValue === '-.') {
															rowToUpdate.tempAllocatedInput = inputValue;
															rowToUpdate.allocatedAmount = undefined;
															rowToUpdate.isInvalidAllocation = false;
															rowToUpdate.hasShownError = false;
															this.setState({ data: updatedRows });
															return;
														}

														// Valid decimal?
														if (validDecimal.test(inputValue) && !isNaN(numericValue)) {
															const input1 = parseFloat(inputValue);
															const input2 = parseFloat(remaining);

															// 🚫 Positive not allowed if remaining is negative
															if (input2 < 0 && input1 > 0) {
																rowToUpdate.tempAllocatedInput = inputValue;
																rowToUpdate.allocatedAmount = input1;
																rowToUpdate.isInvalidAllocation = true;
																this.setState({ data: updatedRows });
																return;
															}

															// 🚫 Allocated > remaining (for positive remaining)
															if (input2 >= 0 && input1 > input2) {
																rowToUpdate.tempAllocatedInput = inputValue;
																rowToUpdate.allocatedAmount = input1;
																rowToUpdate.isInvalidAllocation = true;
																this.setState({ data: updatedRows });
																return;
															}

															// 🚫 Allocated more negative than allowed (for negative remaining)
															if (input2 < 0 && input1 < input2) {
																rowToUpdate.tempAllocatedInput = inputValue;
																rowToUpdate.allocatedAmount = input1;
																rowToUpdate.isInvalidAllocation = false;
																this.setState({ data: updatedRows });
																return;
															}

															// Warn if over total invoice allocation (optional)
															if (totalAllocatedIncludingThis > invoiceLineAmount) {
																rowToUpdate.tempAllocatedInput = inputValue;
																rowToUpdate.allocatedAmount = numericValue;
															} else {
																// ✅ Valid input
																rowToUpdate.tempAllocatedInput = inputValue;
																rowToUpdate.allocatedAmount = numericValue;
																rowToUpdate.isInvalidAllocation = false;
																rowToUpdate.hasShownError = false;
															}

															this.setState({ data: updatedRows });
														}
													}}

													onBlur={(e) => {
														const updatedRows = [...this.state.data];
														const index = updatedRows.findIndex(r => r.rowId === row.rowId);
														if (index !== -1) {
															const r = updatedRows[index];
															let value = e.target.value.trim();

															// Remove invalid partial values like "-", ".", or "-."
															if (value === '-' || value === '.' || value === '-.') {
																value = '';
															}

															// Normalize ".75" -> "0.75" and "-.75" -> "-0.75"
															if (/^-?\.\d+$/.test(value)) {
																value = value.replace(/^(-?)\./, '$10.');
															}

															// If empty after cleanup, reset to "0.00"
															if (value === '') {
																value = '0.00';
															}

															const numericValue = parseFloat(value);

															if (!isNaN(numericValue) && !r.isInvalidAllocation) {
																// Apply formatNumber() on blur
																const formatted = formatNumber(numericValue);
																r.tempAllocatedInput = undefined;
																r.allocatedAmount = numericValue;
																e.target.value = formatted;
															} else {
																// Handle invalid numeric values safely
																r.tempAllocatedInput = undefined;
																r.allocatedAmount = 0;
																e.target.value = '0.00';
															}

															this.setState({ data: updatedRows });
														}
													}}
												/>
											);
										}
									}

								] : []),
								{
									headerName: 'Service Date',
									//field: 'serviceDate',
									field: 'serviceStartDate',
									width: 100,
									sortComparator: (v1, v2, param1, param2) => {
										// 1. Handle empty/null values (push them to the bottom)
										if (!v1 && !v2) return 0;
										if (!v1) return 1;
										if (!v2) return -1;

										// 2. Split the ranges
										const range1 = v1.split(' - ');
										const range2 = v2.split(' - ');

										// 3. Detect current sort direction from the MUI API
										const sortModel = param1.api.getSortModel();
										const columnSort = sortModel.find((m) => m.colId === 'serviceStartDate');
										const direction = columnSort ? columnSort.sort : 'asc';

										let dateA, dateB;

										if (direction === 'desc') {
											// Sort by END DATE (Index 1) when descending
											// Fallback to start date if no end date exists in the string
											dateA = new Date(range1[1] || range1[0]);
											dateB = new Date(range2[1] || range2[0]);
										} else {
											// Sort by START DATE (Index 0) when ascending
											dateA = new Date(range1[0]);
											dateB = new Date(range2[0]);
										}

										// 4. Final Comparison
										return dateA.getTime() - dateB.getTime();
									},
									renderCell: rowData => {
										let date = rowData?.row?.serviceStartDate;
										//let enddate = rowData?.row?.serviceEndDate;
										if (date) {
											return date /*+ ' - ' + enddate*/;
										}
										return '';
									}
								},
								{
									headerName: 'IO/PO Amount',
									field: 'poAmount',
									type: 'currency',
									align: 'right',
									headerAlign: 'right',
									renderCell: rowData => formatNumber(rowData.row.poAmount),
									flex: 0.5
								},
								{
									headerName: 'Consumed Amount',
									field: 'consumedAmount',
									type: 'currency',
									align: 'center',
									headerAlign: 'center',
									renderCell: rowData => formatNumber(rowData.row.consumedAmount),
									flex: 0.5
								},
								{
									headerName: 'Remaining Amount',
									type: 'currency',
									field: 'remainingAmount',
									align: 'center',
									headerAlign: 'center',
									renderCell: (rowData) => {
										const row = rowData.row;
										const allocated = parseFloat(row.allocatedAmount) || 0;
										const remaining = row.poAmount - row.consumedAmount - allocated;
										const formatted = formatNumber(remaining);
										return (
											<div title={`${formatted}`}>
												{formatted}
											</div>
										);
									},
									flex: 0.5
								},

								{
									headerName: 'Delivery Amount',
									field: 'deliveryAmount',
									type: 'currency',
									align: 'center',
									headerAlign: 'center',

									renderCell: rowData => formatNumber(rowData.row.deliveryAmount),
									flex: 0.5
								},
								{
									headerName: 'Currency',
									field: 'currencyCode',
									width: 80
								},
								{
									headerName: 'Client Name',
									field: 'clientName',
									flex: 0.5,
									renderCell: rowData => {
										const value = rowData.row.clientName || '';
										return (
											<Tooltip title={value} placement="top" disableHoverListener={!value}>
												<div style={{ width: '100%', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden', textOverflow: 'ellipsis', maxHeight: '2.4em' }}>
													{value}
												</div>
											</Tooltip>
										);
									}
								},
								{
									headerName: 'Job Code',
									field: 'jobCode',
									flex: 0.5
								},
								{
									headerName: (this.props.info.modelDefId === 2 ? 'Job Name' : 'Campaign Name'),
									field: 'campaignName',
									flex: 1,
									renderCell: rowData => {
										const value = rowData.row.campaignName || '';
										return (
											<Tooltip title={value} placement="top" disableHoverListener={!value}>
												<div style={{ width: '100%', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden', textOverflow: 'ellipsis', maxHeight: '2.4em' }}>
													{value}
												</div>
											</Tooltip>
										);
									}
								},
								{
									headerName: 'Media Plan Name',
									field: 'mediaPlanName',
									flex: 1,
									renderCell: rowData => {
										const value = rowData.row.mediaPlanName || '';
										return (
											<Tooltip title={value} placement="top" disableHoverListener={!value}>
												<div style={{ width: '100%', lineHeight: 1.2, whiteSpace: 'normal', overflowWrap: 'anywhere', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden', textOverflow: 'ellipsis', maxHeight: '2.4em' }}>
													{value}
												</div>
											</Tooltip>
										);
									}
								}
							]}
							customcomponent={this.getRefreshButton()}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={this.close_clickHandler} color="primary">
						Select
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
